import Vue from 'vue'
import VueRouter from 'vue-router'
import { firestorePlugin } from 'vuefire'
import App from './App.vue'
import ConversationList from './components/ConversationList.vue'
import Conversation from './components/Conversation.vue'
import JoinScreen from './components/JoinScreen.vue'

Vue.config.productionTip = false

Vue.use(firestorePlugin)
Vue.use(VueRouter)

function isMember(conversationId) {
  if (localStorage.conversationMap) {
    let conversationMap = JSON.parse(localStorage.conversationMap)
    return (conversationId in conversationMap);
  } else {
    return false;
  }
}

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/start' },
    { path: '/conversations', component: ConversationList },
    { path: '/start', component: JoinScreen, props: { startNewConversation: true } },
    {
      path: '/:conversationId', component: Conversation, props: true, beforeEnter: (to, from, next) => {
        const { conversationId } = to.params;
        if (!isMember(conversationId)) {
          next('/join/' + conversationId);
        } else {
          next();
        }
      }
    },
    {
      path: '/join/:conversationId/:suggestedName?', component: JoinScreen, props: true, beforeEnter: (to, from, next) => {
        const { conversationId } = to.params;
        if (isMember(conversationId)) {
          next('/' + conversationId);
        } else {
          next();
        }
      }
    }
  ]
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
